import { aboutInfo } from '@/mocks/site';

export default function AboutReputation() {
  const { reputation } = aboutInfo;

  return (
    <section className="mb-16">
      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
        {reputation.title}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {reputation.items.map((item, idx) => (
          <div key={idx} className="bg-background-100 rounded-lg p-5">
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <i
                  key={i}
                  className={`text-sm ${i < item.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                ></i>
              ))}
            </div>
            <p className="text-foreground-700 text-sm leading-relaxed mb-4">
              &ldquo;{item.comment}&rdquo;
            </p>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-foreground-900 text-sm font-medium">{item.name}</p>
                <p className="text-foreground-500 text-xs">{item.role}</p>
              </div>
              <span className="text-foreground-400 text-xs">{item.date}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}